<template>
    <tr class="text-xs-center nowrap">
        <td class="pa-0 firstWeekRow">
            <div class="cell">
                <v-avatar 
                    v-if="item.locationHasAlert" 
                    :color="item.locationAlertLevelColor"
                    class="mr-1"
                    size="24">
                </v-avatar>
                <span>{{ item.locationName }}</span>
            </div>
        </td>
        <td class="pa-0">
            <div class="cell">
                <v-btn flat block @click="$emit('goToDetail')">
                    <v-avatar 
                        v-if="item.rotationDays" 
                        color="primary"
                        class="mr-1"
                        size="24">
                        <span class="white--text">{{ item.rotationDays }}</span>
                    </v-avatar>
                    <span>{{ item.varietyName }}</span>
                </v-btn>
            </div>
        </td>
        <td class="pa-0">
            <div v-if="showYieldValues" class="small-cell">TY</div>
            <div v-if="showProfileValues" class="small-cell">P</div>
            <div class="small-cell">F</div>
            <div v-if="!forecastWeek.isFutureWeek" class="small-cell">A</div>
        </td>
        <td></td>
        <td v-if="!isWeekBulk"
            class="info lighten-4"
            style="min-width: 100px; padding: 0px; position:relative;"
            align="center"
            :id="'week-'+ item.cropLocationId + '-' + item.varietyId + '-' + 0"
            @keydown.esc="closeWeekEdit(false)"
            @click="openWeekEdit()">
            <template>
                <div v-if="hasNonZeroSpray(forecastWeek)" class="info-mark error--text">
                    !
                </div>
                <!-- <div v-if="showYieldValues" class="small-cell">
                    <span v-if="`${forecastWeek.totalYields}`">{{forecastWeek.totalYields}}</span>
                    <span v-else>N/A</span>
                </div> -->
                <div v-if="showYieldValues" class="small-cell">
                    <v-layout align-center justify-center row fill-height>
                        <v-checkbox tabindex="-1" v-if="`${forecastWeek.totalYields}` && !forecastWeek.locked" :input-value="isYieldChecked(forecastWeek)" hide-details v-on:click.stop.prevent="applyYield(forecastWeek)"></v-checkbox>
                        <span v-if="`${forecastWeek.totalYields}`">{{forecastWeek.totalYields}}</span>
                        <span v-else>N/A</span>
                    </v-layout>
                </div>
                <div v-if="showProfileValues" class="small-cell">
                    <v-layout align-center justify-center row fill-height>
                        <v-checkbox tabindex="-1" v-if="`${forecastWeek.totalProfiles}` && !forecastWeek.locked" :input-value="isProfileChecked(forecastWeek)" hide-details v-on:click.stop.prevent="applyProfile(forecastWeek)"></v-checkbox>
                        <span v-if="`${forecastWeek.totalProfiles}`">{{forecastWeek.totalProfiles}}</span>
                        <span v-else>N/A</span>
                    </v-layout>
                </div>
                <div v-if="weekEditMode">
                    <EditTableCell
                        style="width: 100px"
                        label="Forecast"
                        :value="`${forecastWeek.total}`"
                        @input="modifyWeekForecastValue($event)"
                        @close="closeWeekEdit($event)"
                        :rules="[validateForecastValue]"
                        :loading="weekLoading"
                        :dense="true">
                    </EditTableCell>
                </div>
                <div v-else class="row small-cell  font-weight-bold">
                    <span v-if="`${forecastWeek.total}`">{{ forecastWeek.total }}</span>
                    <span  v-else>N/A</span>
                    <v-icon v-if="forecastWeek.locked">lock_outline</v-icon>
                </div>
                <div class="small-cell" v-if="!forecastWeek.isFutureWeek"><span>{{parseInt(forecastWeek.totalActuals)}}</span></div>
            </template>
        </td>
        <td v-for="(forecastDay, index) in forecastWeek.forecastDays" 
            :key="index" 
            :id="'day-'+ item.cropLocationId + '-' + item.varietyId + '-' + index"
            :class="`${forecastDay.Withholding ? forecastDay.WithholdColour : isSpray(forecastDay) ? `error` : forecastDay.isRotationDay ? `primary` : forecastDay.isToday ? `grey` : !(index < 7) ? `blue-grey` : ``} ${index >= 7 && (isSpray(forecastDay) || forecastDay.isRotationDay) ? 'lighten-3' : 'lighten-4'}`"
            style="min-width: 100px; padding: 0px; position: relative;"
            align="center"
            :tabindex="editable && (!forecastDay.forecastValueLocked || !forecastDay.adjustedValueLocked) ? 0 : null"
            @focus="openEdit(index)"
            @keydown.esc="closeEdit(index, false)"
            @click="openEdit(index)">
            <template>
                 <div v-if="forecastDay.hasRoster" class="info-mark info--text">
                    i
                </div>
                <div v-if="showYieldValues" class="small-cell"></div>
                <div v-if="showProfileValues" class="small-cell"></div>
                <div v-if="editMode.indexOf(index) >= 0">
                    <EditTableCell
                        style="width: 100px"
                        label="Forecast"
                        :value="`${forecastDay.forecastValueLocked && forecastDay.adjustedValue !== '' ? forecastDay.adjustedValue : forecastDay.forecastValue}`"
                        @input="modifyDayForecastValue(index, $event)"
                        @close="closeEdit(index, $event)"
                        :rules="forecastDay.isSpray ? [validateSprayRules] : [validateForecastValue]"
                        :loading="loading.indexOf(index) >= 0"
                        :dense="true">
                    </EditTableCell>
                    <span v-if="forecastDay.hasRoster" class="caption font-italic info--text">Volume has already been rostered</span>
                </div>
                <div v-else class="row small-cell font-weight-bold">
                    <div class="vertical-cell">
                        <div class="row">
                            <span v-if="`${forecastDay.forecastValueLocked && forecastDay.adjustedValue !== '' ? forecastDay.adjustedValue : forecastDay.forecastValue}`">{{ forecastDay.forecastValueLocked && forecastDay.adjustedValue !== '' ? forecastDay.adjustedValue : forecastDay.forecastValue }}</span>
                            <span v-else>N/A</span>
                            <v-icon v-if="forecastDay.forecastValueLocked && forecastDay.adjustedValueLocked">lock_outline</v-icon>
                            <v-tooltip v-model="forecastDay.showNuPointSprayDetails" top>
                                <template v-slot:activator="{ on, attrs }">                            
                                    <span><v-img v-if="forecastDay.Withholding" :src="require('@/assets/spray.png')" width="24px" @click="forecastDay.showNuPointSprayDetails = !forecastDay.showNuPointSprayDetails" v-bind="attrs" v-on="on"></v-img></span>
                                    <span><v-chip dark v-if="forecastDay.ICA" :color="forecastDay.ICAColour" small v-bind="attrs" v-on="on" class="ica-icon">ICA</v-chip></span>
                                </template>
                                <NuPointSprayDetails v-if="forecastDay.nuPointSprays.length > 0" :nuPointSprayModels="forecastDay.nuPointSprays" :show="forecastDay.showNuPointSprayDetails" />                                  
                            </v-tooltip>
                        </div>
                    </div>
                </div>
                <div class="small-cell" v-if="!forecastWeek.isFutureWeek"><span v-if="forecastDay.actualValue != ''">{{parseInt(forecastDay.actualValue)}}</span></div>
            </template>
        </td>
        <td></td>
        <OkPopup
            :DisplayDialog="showNuPointWarning"
            DialogTitle="NuPoint Spray"
            DialogContents="WARNING! Location currently under NuPoint Spray"
            DialogColour="warning"
            DialogIcon="pan_tool"
            @ClickedOK="nuPointWarningDismissed()"
        >
        </OkPopup>
    </tr>
</template>

<script>
import EditTableCell from '@/components/forecasting/EditTableCell.vue'
import ForecastingDistributionService from '@/services/forecastingDistributionService'
import NuPointSprayDetails from "@/components/nuPointSpray/NuPointSpray.vue"
import OkPopup from '@/components/generic/OkPopup.vue';
import moment from "moment";

import { mapGetters, mapActions, mapState } from "vuex"

export default {
    components: {
        EditTableCell,
        NuPointSprayDetails,
        OkPopup
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        isWeekBulk: {
            type: Boolean,
            default: false
        },
        forecastWeeksYieldApplied: {
            type: Array,
            required: true
        },
        forecastWeeksProfileApplied: {
            type: Array,
            required: true
        }
    },
    data(){
        return {
            moment,
            weekEditMode: false,
            weekLoading: false,
            showNuPointWarning: false,
            editIdex: null,
            editMode: [],
            loading: []
        };
    },
    computed: {
        ...mapGetters("ForecastingStore", [
            "startOfSelectedWeek",
            "editable"
        ]),
        ...mapState("ForecastingStore", [
            "showProfileValues",
            "showYieldValues"
        ]),
        forecastWeek(){
            return this.item.forecastWeeks.find(x => x.week == this.startOfSelectedWeek)
        }
    },
    methods: {
        ...mapActions("ForecastingStore", [
            "handleForecastChanged",
            "handleForecastsChanged",
            "updateData"
        ]),
        openWeekEdit(){
            if(this.isWeekBulk || !this.editable){
                return;
            }

            if(this.forecastWeek.locked){
                return;
            }

            this.weekEditMode = true;
        },
        closeWeekEdit(isEnter){
            this.weekEditMode = false;
            if(isEnter && this.item.next) {
                document.getElementById('week-'+ this.item.next.cropLocationId + '-' + this.item.next.varietyId + '-' + 0).click();
            }
        },
        openEdit(index, ignoreWarning){
            if(this.isWeekBulk || !this.editable){
                return;
            }

            let forecastDay = this.forecastWeek.forecastDays[index];
            if(forecastDay.forecastValueLocked && forecastDay.adjustedValueLocked){
                return;
            }

            if (!ignoreWarning && forecastDay.nuPointSprays.filter(n => n.Withholding).length > 0) {
                this.showNuPointWarning = true;
                this.editIdex = index;
                return;
            }

            if(this.editMode.indexOf(index) < 0){
                this.editMode.push(index);
            }
        },
        closeEdit(index, isEnter = false){
            if(this.editMode.indexOf(index) >= 0){
                this.editMode.splice(this.editMode.indexOf(index), 1);
            }
            if(isEnter && this.item.next) {
                document.getElementById('day-'+ this.item.next.cropLocationId + '-' + this.item.next.varietyId + '-' + index).click();
            }
        },
        isSpray(forecastDay) {
            return forecastDay.isSpray;
        },
        nuPointWarningDismissed() {
            this.showNuPointWarning = false;
            this.openEdit(this.editIdex, true);
        },
        validateSprayRules(v) {
            if(v == null || !v.match(/^[0]$/)){
                return "Only zero can be captured on a Spray day";
            }

            return false;
        },
        validateForecastValue(v){
            if(v == null || !v.match(/^[0-9]{1,5}$/)){
                return "Please enter a number in the form XXXXX";
            }

            return false;
        },
        async modifyWeekForecastValue(event){
            var newTotal = event.value;
            var isEnter = event.isEnter;
            this.weekLoading = true;
        
            let dayValues = ForecastingDistributionService.getNewDayValuesForForecastWeek(
                newTotal, 
                this.forecastWeek.forecastDays,
                this.forecastWeek.week
            );

            let changesMade = false;
            var forecastDays = [];
            for(let i = 0; i < dayValues.length; i++){
                let changeMade = await this.modifyForecastValue(
                    dayValues[i].day, 
                    dayValues[i].newValue,
                    false
                );
                if(changeMade){
                    forecastDays.push(this.forecastWeek.forecastDays.find(fd=> fd.day == dayValues[i].day));
                    changesMade = true;
                }
            }
            if(changesMade){
                await this.updateData({all: false, forecastDays});
            }

            this.weekLoading = false;
            this.closeWeekEdit(isEnter);
        },
        async modifyDayForecastValue(index, event){
            var newValue = event.value;
            var isEnter = event.isEnter;
            if(this.loading.indexOf(index) < 0){
                this.loading.push(index);
            }

            let changeMade = await this.modifyForecastValue(
                this.forecastWeek.forecastDays[index].day, 
                newValue, 
                true
            );
            if(changeMade){
                await this.updateData({all: false, forecastDays: [this.forecastWeek.forecastDays[index]]});
            }

            if(this.loading.indexOf(index) >= 0){
                this.loading.splice(this.loading.indexOf(index), 1);
            }
            this.closeEdit(index, isEnter);
        },
        async modifyForecastValue(day, newValue, allowZeroes){
            let forecastDay = this.forecastWeek.forecastDays.find(x => x.day == day);

            // Start without any changes
            let newForecastValue = forecastDay.forecastValue;
            let newAdjustedValue = forecastDay.adjustedValue;

            if(!forecastDay.forecastValueLocked){
                // Update the forecast value
                newForecastValue = newValue;

                // If the forecast value was blank and it is now being set to 0
                // Leave it as blank
                if(newForecastValue === 0 && forecastDay.forecastValue === "" && !allowZeroes){
                    newForecastValue = "";
                }
            } else if(!forecastDay.adjustedValueLocked){
                // Update the adjusted value
                newAdjustedValue = newValue;

                // If the adjusted value was blank and it is now being set to 0
                // Leave it as blank
                if(newAdjustedValue === 0 && forecastDay.adjustedValue === "" && !allowZeroes){
                    newAdjustedValue = "";
                }
            }

            // If the values haven't changed, no need to send a modification
            if(newForecastValue === forecastDay.forecastValue 
            && newAdjustedValue === forecastDay.adjustedValue){
                return false;
            }

            // Return a modification
            await this.handleForecastChanged({
                cropLocationId: this.item.cropLocationId,
                varietyId: this.item.varietyId,
                date: day,
                forecastValue: newForecastValue === "" ? null : newForecastValue,
                adjustedValue: newAdjustedValue === "" ? null : newAdjustedValue,
            });

            return true;
        },
        hasNonZeroSpray(forecastWeek) {
            return forecastWeek.forecastDays.some(forecastDay=> {
                let value = forecastDay.forecastValueLocked && forecastDay.adjustedValue !== '' ? forecastDay.adjustedValue : forecastDay.forecastValue;
                return forecastDay.isSpray && value > 0;
            });
        },
        isYieldChecked(forecastWeek) {
            return this.forecastWeeksYieldApplied.findIndex(y=> y.week == forecastWeek.week && y.cropLocationId == this.item.cropLocationId && y.varietyId == this.item.varietyId) > -1;
        },
        applyYield(forecastWeek) {
            this.$emit("onYieldsApplied", { week: forecastWeek.week, cropLocationId: this.item.cropLocationId, varietyId: this.item.varietyId});
        },
        isProfileChecked(forecastWeek) {
            return this.forecastWeeksProfileApplied.findIndex(y=> y.week == forecastWeek.week && y.cropLocationId == this.item.cropLocationId && y.varietyId == this.item.varietyId) > -1;
        },
        applyProfile(forecastWeek) {
            this.$emit("onProfilesApplied", { week: forecastWeek.week, cropLocationId: this.item.cropLocationId, varietyId: this.item.varietyId});
        },
    },
    created(){

    }
}
</script>

<style scoped>
    .ica-icon {
        font-size: 11px;
        width: 26px;
        justify-content: center;
    }

    .nowrap {
        white-space: nowrap;
    }

    .cell {
        height: 60px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    .small-cell {
        min-height: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .vertical-cell {
        height: 60px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .row {
        height: 24px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
    }

    .firstWeekRow {
        position: -webkit-sticky;
        position: sticky;
        left: 0;
        z-index: 10;
        background: white;
    }
   
    .info-mark {
        position: absolute;
        top: 0;
        right: 0;
        margin-right: 4px;
        font-weight: bold;
        font-size: 15px;
    }
    
    table tbody td {
        font-size:18px;
    }
</style>